import styled from 'styled-components'

export const tabTipoLancamentoParceiro = {
  Container: styled.div`
    margin: 16px;
  `
}
